import { render, staticRenderFns } from "./viewerpdfArboles.vue?vue&type=template&id=3c8daa2c&"
import script from "./viewerpdfArboles.vue?vue&type=script&lang=ts&"
export * from "./viewerpdfArboles.vue?vue&type=script&lang=ts&"
import style0 from "./viewerpdfArboles.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports